/**
 * aw26-sticky-buy-bar.js
 * Drives the mobile sticky buy bar (snippets/aw26-sticky-buy-bar.liquid).
 *
 * - Visibility: an IntersectionObserver on the real buy-buttons block toggles
 *   the bar once that block has scrolled above the viewport.
 * - Add: delegates a click to the real add-to-cart submit button, so the bar
 *   reuses the theme's variant/validation/drawer flow (no second cart path).
 * - Size pill: scrolls back up to the real variant picker (single source of
 *   truth) and gives it a brief highlight.
 * - Sync: on variant:update the price/size/availability are copied from the
 *   freshly server-rendered section fragment, guaranteeing they match the main
 *   controls exactly.
 */
(function () {
  if (window.__aw26StickyBuyBarBound) return;
  window.__aw26StickyBuyBarBound = true;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getBar() {
    return document.querySelector('[data-aw26-sticky]');
  }

  /* ---- Visibility -------------------------------------------------------- */
  function setupObserver() {
    var bar = getBar();
    if (!bar) return;

    // Stable sentinel: the buy-buttons wrapper is not swapped on variant
    // change (only the inner add-to-cart button is), so the observer stays
    // valid across variant updates.
    var sentinel =
      document.querySelector('.product-information .product-form-buttons') ||
      document.querySelector('.buy-buttons-block') ||
      (bar.dataset.submitId && document.getElementById(bar.dataset.submitId));

    if (!sentinel || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry) return;
        // Show only once the buy button has scrolled ABOVE the viewport.
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
        bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
      },
      { threshold: 0, rootMargin: '0px 0px 0px 0px' }
    );
    observer.observe(sentinel);
  }

  /* ---- Interactions (delegated, survive fragment sync) ------------------- */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-aw26-sticky-add]');
    if (addBtn) {
      if (addBtn.disabled) return;
      e.preventDefault();
      var bar = addBtn.closest('[data-aw26-sticky]');
      var submitId = bar && bar.dataset.submitId;
      var realBtn =
        (submitId && document.getElementById(submitId)) ||
        document.querySelector('.product-information [ref="addToCartButton"]') ||
        document.querySelector('product-form-component [ref="addToCartButton"]');
      if (realBtn) realBtn.click();
      return;
    }

    var sizeBtn = e.target.closest('[data-aw26-sticky-size]');
    if (sizeBtn) {
      e.preventDefault();
      var picker =
        document.querySelector('.product-information variant-picker') ||
        document.querySelector('variant-picker');
      if (!picker) return;
      picker.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'center' });
      picker.classList.remove('aw26-picker-flash');
      // Force reflow so the animation can restart on repeated taps.
      void picker.offsetWidth;
      picker.classList.add('aw26-picker-flash');
      window.setTimeout(function () {
        picker.classList.remove('aw26-picker-flash');
      }, 1200);
    }
  });

  /* ---- Keep price/size/availability in sync with the main controls ------ */
  document.addEventListener('variant:update', function (e) {
    var html = e.detail && e.detail.data && e.detail.data.html;
    var live = document.querySelector('[data-aw26-sticky-sync]');
    if (!html || !live) return;
    var next = html.querySelector ? html.querySelector('[data-aw26-sticky-sync]') : null;
    if (next) live.innerHTML = next.innerHTML;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver, { once: true });
  } else {
    setupObserver();
  }
})();
